import script from "./UserReportOkrElementsLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./UserReportOkrElementsLoader.vue?vue&type=script&setup=true&lang=js"

import "./UserReportOkrElementsLoader.vue?vue&type=style&index=0&id=2e65571a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e65571a"]])

export default __exports__